module.exports = __webpack_public_path__ + "static/media/pokemonlogo.svg.0bda2da2.png";